function Emoji({ children }: { children: string }) {
  return (
    <span className="element inline-flex min-h-6 min-w-6 items-center justify-center">
      {children}
    </span>
  )
}
Emoji.displayName = 'EmojiIcon'

export { Emoji }
